import * as React from 'react'
import type { TimelineScene } from '../scene/TimelineScene'

const SceneContext = React.createContext<TimelineScene | null>(null)

export const SceneProvider = SceneContext.Provider

export const useScene = (): TimelineScene => {
  const scene = React.useContext(SceneContext)
  if (!scene) {
    throw new Error('useScene must be used inside <SceneProvider>')
  }
  return scene
}
